/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Default Messages
 *
 * @file defaultMessages.js
 * @author Moahmed yasar arabath M
 */

import { defineMessages } from 'react-intl';

const messages = defineMessages({
  instructor: {
    id: 'instructor',
    defaultMessage: 'Instructor'
  },
  startDate: {
    id: 'startDate',
    defaultMessage: 'Start date'
  },
  endDate: {
    id: 'endDate',
    defaultMessage: 'End date'
  },
  review: {
    id: 'reviewComponent.review',
    defaultMessage: 'Review'
  },
  noTopicsAtThisTime: {
    id: 'leftAccordionList.noTopicsAtThisTime',
    defaultMessage: 'No Topics at this time'
  },
  needsReview: {
    id: 'mcqComponent.needsReview',
    defaultMessage: 'Needs review'
  },
  gettingThere: {
    id: 'mcqComponent.gettingThere',
    defaultMessage: 'Getting there'
  },
  great: {
    id: 'mcqComponent.great',
    defaultMessage: 'Great'
  },
  attempts: {
    id: 'mcqComponent.attempts',
    defaultMessage: 'attempts'
  },
  correctAnswer: {
    id: 'mcqComponent.correctAnswer',
    defaultMessage: 'Correct answer'
  },
  okay: {
    id: 'mcqComponent.okay',
    defaultMessage: 'Okay'
  },
  download: {
    id: 'download',
    defaultMessage: 'Download eTextbook'
  },
  downloading: {
    id: 'downloading',
    defaultMessage: 'Downloading'
  },
  extracting: {
    id: 'extracting',
    defaultMessage: 'Extracting'
  }
});

export default messages;
